<template>
  <div>
    <!-- User application to offer report -->
    <div
      v-if="$hasRole(['employer'])"
      class="bg-card"
    >
      <h1>{{ $t('pages.my-account.notifications.title', 'Notifications') }}</h1>
      <h3>{{ $t('pages.my-account.notifications.new-applications.title', 'New applications') }}</h3>
      <div>{{ $t('pages.my-account.notifications.new-applications.caption', 'Receive emails about new applications') }}</div>
      <div class="mt-3">
        <label>{{ $t('pages.my-account.notifications.new-applications.notifications-period', 'Notifications periodicity') }}</label>
        <b-form-group>
          <b-form-checkbox
            id="dailyNewApplication"
            v-model="employerNotifs.dailyNewApplication.value"
            name="dailyNewApplication"
          >
            {{ $t('pages.my-account.notifications.new-applications.daily-email', 'Daily notification about new applications') }}
          </b-form-checkbox>
          <b-form-checkbox
            id="instantNewApplication"
            v-model="employerNotifs.instantNewApplication.value"
            name="instantNewApplication"
          >
            {{ $t('pages.my-account.notifications.new-applications.instant-email', 'Instant notification about new applications') }}
          </b-form-checkbox>
        </b-form-group>
        <b-button
          size="sm"
          :disabled="!hasSettingsChanged"
          variant="success"
          @click="saveSettings"
        >
          {{ $t('pages.my-account.notifications.submit', 'Save settings') }}
        </b-button>
      </div>
    </div>
    <div
      v-else-if="$hasRole(['candidate'])"
      class="bg-card"
    >
      <h1>{{ $t('pages.my-account.notifications.title', 'Notifications') }}</h1>
      <h3>{{ $t('pages.my-account.notifications.candidate-offers.title', 'Configure your notifications') }}</h3>
      <div>{{ $t('pages.my-account.notifications.candidate-offers.caption', 'Select notifications to receive through emails') }}</div>
      <b-form-group>
        <b-form-checkbox
          id="newOffers"
          v-model="candidateNotifs.newOffers.value"
          name="newOffers"
        >
          {{ $t('pages.my-account.notifications.candidate-offers.daily-new-offers', 'New offers daily report') }}
        </b-form-checkbox>
        <b-form-checkbox
          id="applicationStatus"
          v-model="candidateNotifs.applicationStatus.value"
          name="applicationStatus"
        >
          {{ $t('pages.my-account.notifications.candidate-offers.application-status-change', 'Application status change') }}
        </b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="$hasRole(['admin'])">
        <b-form-checkbox
          id="newCompanies"
          v-model="adminNotifs.newCompanies.value"
          name="newCompanies"
        >
          {{ $t('pages.my-account.notifications.admin.new-companies', 'New companies registered report') }}
        </b-form-checkbox>
      </b-form-group>
      <b-button
        size="sm"
        :disabled="!hasSettingsChanged"
        variant="success"
        @click="saveSettings"
      >
        {{ $t('generic.save-changes', 'Save changes') }}
      </b-button>
    </div>
    <div
      v-else-if="$hasRole(['hr']) || this.$hasRole(['admin'])"
      class="bg-card"
    >
      <h1>{{ $t('pages.my-account.notifications.title', 'Notifications') }}</h1>
      <h3>{{ $t('pages.my-account.notifications.admin.title', 'Configure your notifications') }}</h3>
      <p>{{ $t('pages.my-account.notifications.admin.caption', 'Currently there are nothing to configure') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mySettings: [],
      candidateNotifs: {
        newOffers: {
          key: 'candidates.report-new-offers.enabled',
          value: false
        },
        applicationStatus: {
          key: 'candidates.report-application-status.enabled',
          value: false
        }
      },
      adminNotifs: {
        newCompanies: {
          key: 'admin.report-new-companies.enabled',
          value: false
        }
      },
      employerNotifs: {
        dailyNewApplication: {
          key: 'companies.report-applications.enabled',
          value: false
        },
        instantNewApplication: {
          key: 'companies.realtime-applications.enabled',
          value: false
        }
      }
    }
  },
  computed: {
    hasSettingsChanged() {
      const settings = { ...this.determineSettings() };
      for (let settingsKey in settings) {
        if (!settings.hasOwnProperty(settingsKey)) {
          continue;
        }

        let uiSetting = settings[settingsKey];
        let foundSetting = this.mySettings.find(item => item.key === uiSetting.key);
        if (!foundSetting && uiSetting.value === true) {
            return true;
        }
        if (foundSetting && Number(uiSetting.value) !== Number(foundSetting.value)) {
          return true;
        }
      }

      return false;
    }
  },

  mounted() {
    this.getMySettings();
  },

  methods: {
    getMySettings() {
      this.axios.get('/users/settings/get')
        .then( response => {
          this.mySettings = response.data;
          this.setSettingsView();
        })
        .catch();
    },

    setSettingsView() {
      for (let notif of this.mySettings) {
        // Admin
        if (notif.key === this.adminNotifs.newCompanies.key && notif.value == 1) {
          this.adminNotifs.newCompanies.value = true;
        }
        // Employer
        if(notif.key === this.employerNotifs.dailyNewApplication.key && notif.value == 1) {
          this.employerNotifs.dailyNewApplication.value = true;
        }
        if(notif.key === this.employerNotifs.instantNewApplication.key && notif.value == 1) {
          this.employerNotifs.instantNewApplication.value = true;
        }
        // Candidate
        if (notif.key === this.candidateNotifs.newOffers.key && notif.value == 1) {
          this.candidateNotifs.newOffers.value = true;
        }
        if (notif.key === this.candidateNotifs.applicationStatus.key && notif.value == 1) {
          this.candidateNotifs.applicationStatus.value = true;
        }
      }
    },

    determineSettings() {
        let data;
        if (this.$hasRole(['employer'])) {
            data = this.employerNotifs;
        } else if (this.$hasRole(['candidate'])) {
            data = this.candidateNotifs;
        } else if (this.$hasRole(['admin'])) {
            data = this.adminNotifs;
        }
        return data;
    },

    saveSettings() {
      this.axios.post('/users/settings', this.determineSettings())
        .then((data) => {
          this.mySettings = data.data.data;
          this.$toastNotification('success', '',
              data.data.changed
                  ? this.$t('pages.my-account.notifications.changes-successful')
                  : this.$t('pages.my-account.notifications.no-changes-made')
          );
        })
        .catch();
    }
  }
}
</script>
